<template>
  <div class="modal-size-advice-cleed-v2">
    <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap" rel="stylesheet">
    <div class="header-cleed">
      <span class="close-modal-cleed" @click="$emit('close')">
        <svg viewBox="0 0 24 24">
          <line x1="5" y1="5" x2="19" y2="19" />
          <line x1="5" y1="19" x2="19" y2="5" />
        </svg>
      </span>
    </div>
    <div class="wrapper-cleed">
      <SizeRecommendationShoes v-if="$store.state.config.storeId == 20" :value-text="valueText"
        :dataLayerPath="dataLayerPath" @close="closeModalRecoSizeModal" />
      <SizeRecommendationNoo v-if="$store.state.config.storeId == 46" :value-text="valueText"
        @close="closeModalRecoSizeModal" @contact-us="contactUs" />
      <SizeRecommendationShoes v-if="$store.state.config.storeId == 33" :value-text="valueText"
        :dataLayerPath="dataLayerPath" @close="closeModalRecoSizeModal" />
      <div class="doute" style="align-items: end;">
        <span class="doute_underline" @click="contactUs">
          {{ valueText['modal_size_reco']['doubt']['text_underline'] }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import store from "../../store";
const eb = require("@/services/eventBus");

import SizeRecommendationNoo from "./SizeRecommendationNoo.vue";
import SizeRecommendationShoes from "./SizeRecommendationShoes.vue";
import { customLogger } from "@/utils";
import specs from "@/specs";

export default {
  name: "SizeRecommendation",
  components: {
    SizeRecommendationNoo,
    SizeRecommendationShoes
  },
  props: {
    boxStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valueText: store.state.config.i18n[store.state.user.lang],
      email: {
        "46": "votretaille@noounderwear.fr",
        "20": "serviceclient@manbow.fr"
      },
      dataLayerPath: specs._DATALAYER_PATH,
    };
  },
  mounted() {
    if (this.$store.state.config.storeId == 20 || this.$store.state.config.storeId == 33) {
      const fontcss = `
        .modal-size-advice-cleed-v2 * {
          font-family: "IBM Plex Sans", sans-serif !important;
        }
      `
      let company_style = document.createElement("style");
      company_style.innerHTML = fontcss;
      document.body.appendChild(company_style);
    } else if (this.$store.state.config.storeId == 46) {
      const fontcss = `
        .modal-size-advice-cleed-v2 * {
          font-family: 'Helvetica Neue', sans-serif !important;
        }

        .title-size-cleed {
          font-weight: normal;
        }
      `
      let company_style = document.createElement("style");
      company_style.innerHTML = fontcss;
      document.body.appendChild(company_style);
    }
    // const css = `

    //   `;

    // // .doute.stick-to-bottom
    // let company_style = document.createElement("style");
    // company_style.innerHTML = css;
    // document.body.appendChild(company_style);
  },
  methods: {
    closeModalRecoSizeModal() {
      if (this.$store.state.user.modal_reco_sizeModal)
        this.$store.state.user.modal_reco_sizeModal = false;
    },
    openBox() {
      eb.emit("BoxOpen");
    },
    contactUs() {
      this.$emit('close');
      if (this.boxStatus)
        this.openBox();
      else {
        try {
          window.location.href = `mailto:${this.email[this.$store.state.config.storeId]}`;
        }
        catch (e) {
          customLogger("mail not found");
        }
      }
    }
  },
};
</script>

<style scoped>
.modal-size-advice-cleed-v2 {
  width: 400px !important;
  max-width: 400px !important;
  margin: 0 auto !important;
  background-color: white;
  border: 1px solid #888 !important;
  top: 50% !important;
  position: fixed !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  min-height: 550px !important;
  max-height: 620px !important;
  overflow-y: auto !important;
  padding: 40px !important;

  display: grid !important;

  box-sizing: unset !important;
}

@media screen and (max-width: 450px) {
  .modal-size-advice-cleed-v2 {
    width: 100% !important;
    max-width: 380px !important;
    padding: inherit !important;
    padding-top: 20px !important;
    padding-bottom: 20px !important;
    box-sizing: border-box !important;
  }
}

.wrapper-cleed {
  width: 100%;
  /* display: flex; */
  flex-direction: column;
  align-items: center;
  /* padding: 20px; */

  flex-grow: 1 !important;
  justify-content: center !important;
  align-items: center !important;
  flex-shrink: 0 !important;
}

.close-modal-cleed {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
}

.close-modal-cleed svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: #333;
  stroke-width: 1px;
  stroke-linecap: round;
}

.doute {
  display: flex !important;
  justify-content: flex-end !important;
  font-size: 14px !important;
  margin-right: 16px;
  color: #000 !important;
  /* margin-bottom: 10px !important; */
  cursor: pointer !important;
  text-align: center !important;
  font-style: italic !important;
}


/* @media screen and (max-width: 375px) {
  .modal-size-advice-cleed {
    width: 100% !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    padding-top: 30px !important;
  }
} */

/* @media screen and (max-height: 600px) {
  .modal-size-advice-cleed {
    max-height: 100vh !important;
    min-height: 100vh !important;
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
} */

/* .modal-size-advice-cleed .header-cleed {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
} */

.header-cleed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>

<style>
.wrapper-cleed:has(.NooClass) {
  display: flex !important;
}

@media screen and (max-width: 450px) {
  .result-size-reco-noo-cleed {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
}

@media screen and (max-width: 375px) {
  .result-size-reco-noo-cleed {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
}

@media screen and (min-width: 451px) {
  .result-size-reco-noo-cleed {
    width: 350px !important;
  }
}

.size-cleed,
.brand-cleed {
  width: 100% !important;
  margin-bottom: 20px;
}

.title-size-cleed {
  text-align: center;
  margin-top: 50px;
  margin-bottom: 30px;
  margin-left: 20px;
  margin-right: 20px;
}

.loader-basic-cleed {
  margin: auto !important;
  display: block !important;
  width: max-content !important;
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.result-size-reco-noo-cleed {
  height: 350px !important;
  display: grid !important;
  text-align: center !important;
  margin-right: 20px !important;
  margin-left: 20px !important;
}

.result-size-reco-noo-cleed.space-evenly {
  align-content: space-evenly !important;
}

.result-size-reco-noo-cleed.baseline {
  align-content: baseline !important;
}

.result-size-reco-noo-cleed .result-size-cleed {
  display: flex !important;
  max-width: max-content !important;
  margin: auto !important;
  align-items: center !important;
  padding-left: 30px !important;
  padding-right: 30px !important;
}

.validateButtonSubmitNoo-cleed {
  background-image: linear-gradient(178deg, rgb(214, 205, 189), rgb(214, 205, 189) 10%, rgba(0, 0, 0, .07) 10%, rgba(0, 0, 0, .07) 100%), linear-gradient(178deg, rgb(214, 205, 189), rgb(214, 205, 189)) !important;
  min-height: 50px !important;
  padding: 5px 15px !important;
  background-size: 100% 200%, 100% 100%;
  background-position: 100% -100%, 100% 100%;
  background-repeat: no-repeat;
  transition: background-position .3s cubic-bezier(.215, .61, .355, 1);
  transform: translateZ(0);
  text-align: center !important;
  border-radius: 2px !important;

  box-sizing: unset !important;
}

.validateButtonSubmitNoo-cleed.rounded {
  padding: 10px !important;
  margin: 3px !important;
  border-radius: 50% !important;
  width: 50px !important;
  height: 50px !important;
}

.validateButtonSubmitNoo-cleed.rounded2 {
  padding: 10px !important;
  margin: 3px !important;
  border-radius: 50% !important;
  width: 65px !important;
  height: 65px !important;
}

.validateButtonSubmitNoo-cleed.rounded5 {
  margin: 0px !important;
  border-radius: 50% !important;
  width: 30px !important;
  height: 30px !important;
}

.validateButtonSubmitNoo-cleed.rounded4 {
  padding: 0px !important;
  margin: 2px !important;
  border-radius: 50% !important;
  width: 50px !important;
  height: 30px !important;
}

.validateButtonSubmitNoo-cleed.preline {
  white-space: pre-line !important;
  word-break: break-word !important;
}

.validateButtonSubmitNoo-cleed:hover.validateCursorPointer-cleed {
  background-position: 100% 25%, 100% 100%;
}

.validateCursorPointer-cleed {
  cursor: pointer !important;
}
</style>
